import fetch from "fetch-retry";
export default fetch(global.fetch);
//# sourceMappingURL=fetch.js.map